<template>
  <div class="select-bank-account">
    <NavBack/>
    <div class="fixed-background sticky-header">
      <MenuAndLogo></MenuAndLogo>
    </div>
    <div class="has-padding">
      <div class="page-title has-text-weight-semibold has-text-centered">Add new bank</div>
      <div class="main has-background-white has-text-centered">
        <div class="has-text-weight-semibold box-title">Manually link your account</div>
        <div class="box-subtitle">What is the financial institution you want to link to your addy account? 🏦</div>
        <BankAutocomplete v-model="bank"></BankAutocomplete>
      </div>
      <BottomButtons
        :showSteps="false"
        :nextDisabled="!bank"
        @goNext="toChequeUploadPage"
        @goBack="goBack"
      ></BottomButtons>
    </div>
  </div>
</template>
<script>
import NavBack from '@components/desktop/header-nav-back.vue'
import MenuAndLogo from '@views/index/MenuAndLogo.vue'
import BankAutocomplete from '@components/input/bank-autocomplete.vue'
import BottomButtons from '@components/button/bottom-buttons.vue'

export default {
  data() {
    return {
      bank: '',
    }
  },
  components: {
    NavBack,
    MenuAndLogo,
    BankAutocomplete,
    BottomButtons,
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    toChequeUploadPage() {
      const data = {
        accountName: this.bank,
      }
      localStorage.setItem('bankAccount', JSON.stringify(data))
      this.$router.push('/wallet/accounts/manual/cheque')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@assets/style/desktop-constants.scss';

.select-bank-account {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  padding-bottom: 80px;
  min-height: 100vh;
  .has-padding {
    padding: 0 25px;
    .page-title {
      font-size: 32px;
      line-height: 32px;
      margin-bottom: 16px;
      letter-spacing: 0.03em;
    }
    .main {
      height: 426px;
      border-radius: 12px;
      box-shadow: 0px 20px 40px rgba(215, 145, 51, 0.15);
      margin-bottom: 27px;
      padding: 0 12px;
      .box-title {
        font-size: 16px;
        padding-top: 24px;
      }
      .box-subtitle {
        padding: 8px 21px 84px;
        font-size: 16px;
        line-height: 19px;
      }
    }
  }
}
@media only screen and (min-width: $min-viewport-width) {
  .select-bank-account {
    padding-top: 19px;
    min-height: $min-height-mobile-container;
    max-width: $mobile-wrapper-width;
    position: unset;
  }
}
</style>
